class TermsOfServiceModalController {
  constructor($scope, $uibModalInstance) {
    $scope.readTheTerms = false

    $scope.accept = function() {
      $uibModalInstance.close()
    }

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel')
    }
  }
}

TermsOfServiceModalController.$inject = ['$scope', '$uibModalInstance']

export default TermsOfServiceModalController
